import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "topo-wrap" }
const _hoisted_2 = { class: "topo-toolbar" }
const _hoisted_3 = { class: "topo-toolbar__group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "topo-search" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "topo-search__count"
}
const _hoisted_8 = { class: "topo-toolbar__group" }
const _hoisted_9 = { class: "topo-live-badge" }
const _hoisted_10 = {
  class: "topo-mode",
  role: "group"
}
const _hoisted_11 = { class: "topo-legend" }
const _hoisted_12 = { class: "topo-legend__item" }
const _hoisted_13 = { class: "topo-legend__item" }
const _hoisted_14 = { class: "topo-legend__item" }
const _hoisted_15 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 m-0 mb-2"
}
const _hoisted_16 = {
  ref: "panelEl",
  class: "topo-panel"
}
const _hoisted_17 = {
  key: 0,
  class: "topo-empty"
}
const _hoisted_18 = { class: "topo-controls" }
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "topo-hint" }
const _hoisted_23 = {
  key: 0,
  class: "topo-departed"
}
const _hoisted_24 = ["aria-expanded"]
const _hoisted_25 = {
  key: 0,
  class: "topo-departed__table"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["aria-expanded"]
const _hoisted_28 = {
  key: 0,
  class: "topo-departed__table"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 1,
  class: "topo-detail"
}
const _hoisted_31 = { class: "topo-detail__head" }
const _hoisted_32 = { class: "topo-detail__title" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "topo-detail__body" }
const _hoisted_35 = { class: "topo-detail__row" }
const _hoisted_36 = { class: "topo-detail__row" }
const _hoisted_37 = {
  key: 1,
  class: "mono"
}
const _hoisted_38 = { class: "topo-detail__row" }
const _hoisted_39 = {
  key: 1,
  class: "topo-detail__row"
}
const _hoisted_40 = { class: "mono" }
const _hoisted_41 = { class: "topo-detail__row" }
const _hoisted_42 = { class: "mono" }
const _hoisted_43 = { class: "topo-detail__row" }
const _hoisted_44 = { class: "topo-detail__row" }
const _hoisted_45 = { class: "topo-detail__row" }
const _hoisted_46 = { class: "topo-detail__row" }
const _hoisted_47 = { class: "topo-detail__row" }
const _hoisted_48 = { class: "topo-detail__row" }
const _hoisted_49 = { class: "topo-detail__row" }
const _hoisted_50 = {
  key: 0,
  class: "topo-detail__row"
}
const _hoisted_51 = { class: "mono" }
const _hoisted_52 = {
  key: 4,
  class: "topo-detail__row"
}
const _hoisted_53 = ["viewBox", "aria-label"]
const _hoisted_54 = ["transform"]
const _hoisted_55 = ["x", "y", "fill"]
const _hoisted_56 = ["opacity"]
const _hoisted_57 = ["x1", "y1", "x2", "y2", "stroke", "stroke-width"]
const _hoisted_58 = ["x", "y", "fill"]
const _hoisted_59 = ["transform", "opacity", "onPointerdown"]
const _hoisted_60 = ["x", "y", "width", "height"]
const _hoisted_61 = ["x", "y", "width", "height", "fill", "stroke"]
const _hoisted_62 = ["y", "fill"]
const _hoisted_63 = ["x", "y", "width", "height"]
const _hoisted_64 = ["x", "y", "width", "height", "fill", "stroke"]
const _hoisted_65 = ["y", "fill"]
const _hoisted_66 = ["r"]
const _hoisted_67 = ["r", "fill", "stroke"]
const _hoisted_68 = ["y", "fill"]
const _hoisted_69 = ["transform"]
const _hoisted_70 = ["stroke"]
const _hoisted_71 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.gwId) = $event)),
          class: "topo-field topo-field--select"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gateways, (g) => {
            return (_openBlock(), _createElementBlock("option", {
              key: g.gwId,
              value: g.gwId
            }, _toDisplayString(g.locationName ?? `${_ctx.$t('components.infrastructure.gateways.unassigned')} · ${g.gwId}`) + _toDisplayString(g.state === 'online' ? '' : ` · ${_ctx.$t('components.infrastructure.topology.detail.offline')}`), 9, _hoisted_4))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.gwId]
        ]),
        _createElementVNode("span", _hoisted_5, [
          _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-search topo-search__icon" }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.q) = $event)),
            class: "topo-field",
            placeholder: _ctx.$t('components.infrastructure.topology.searchPlaceholder')
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.q]
          ]),
          (_ctx.q)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "topo-search__clear",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.q = ''))
              }, [...(_cache[14] || (_cache[14] = [
                _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.q)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.matchSet.size) + " " + _toDisplayString(_ctx.$t('components.infrastructure.topology.matches')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, [
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "wirepas-status-dot wirepas-status-dot--online" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t('components.infrastructure.topology.live')), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", {
            class: _normalizeClass(["topo-mode__thumb", { 'topo-mode__thumb--right': _ctx.mode === 'hierarchical' }])
          }, null, 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["topo-mode__btn", { 'topo-mode__btn--active': _ctx.mode === 'organic' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mode = 'organic'))
          }, _toDisplayString(_ctx.$t('components.infrastructure.topology.modeOrganic')), 3),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["topo-mode__btn", { 'topo-mode__btn--active': _ctx.mode === 'hierarchical' }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.mode = 'hierarchical'))
          }, _toDisplayString(_ctx.$t('components.infrastructure.topology.modeHierarchical')), 3)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "topo-legend__swatch topo-legend__swatch--rect" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t('components.infrastructure.topology.legend.gateway')), 1)
          ]),
          _createElementVNode("span", _hoisted_13, [
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "topo-legend__swatch topo-legend__swatch--diamond" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t('components.infrastructure.topology.legend.anchor')), 1)
          ]),
          _createElementVNode("span", _hoisted_14, [
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "topo-legend__swatch topo-legend__swatch--circle" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t('components.infrastructure.topology.legend.tag')), 1)
          ])
        ])
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _cache[20] || (_cache[20] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      (_ctx.empty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.loading ? _ctx.$t('components.infrastructure.topology.loading') : _ctx.$t('components.infrastructure.topology.empty')), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "button",
                class: "topo-zoom-btn",
                title: _ctx.$t('components.infrastructure.topology.zoomIn'),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.zoomBy(1.3)))
              }, " + ", 8, _hoisted_19),
              _createElementVNode("button", {
                type: "button",
                class: "topo-zoom-btn",
                title: _ctx.$t('components.infrastructure.topology.zoomOut'),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.zoomBy(1 / 1.3)))
              }, " − ", 8, _hoisted_20),
              _createElementVNode("button", {
                type: "button",
                class: "topo-zoom-btn",
                title: _ctx.$t('components.infrastructure.topology.resetView'),
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetView && _ctx.resetView(...args)))
              }, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("i", { class: "bi bi-compass" }, null, -1)
              ]))], 8, _hoisted_21)
            ]),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('components.infrastructure.topology.hint')), 1),
            (_ctx.departedTags.length || _ctx.overflowTags.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_ctx.overflowTags.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "topo-departed__head",
                          "aria-expanded": _ctx.overflowExpanded,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.overflowExpanded = !_ctx.overflowExpanded))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["bi bi-chevron-right topo-departed__chevron", { 'topo-departed__chevron--open': _ctx.overflowExpanded }])
                          }, null, 2),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.parking.graphOverflow')) + " (" + _toDisplayString(_ctx.overflowTags.length) + ")", 1)
                        ], 8, _hoisted_24),
                        (_ctx.overflowExpanded)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_25, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.address')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.battery')), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overflowTags, (n) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: n.id
                                  }, [
                                    _createElementVNode("td", null, [
                                      (_ctx.topoLink(n))
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            to: _ctx.topoLink(n)!
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(n.label), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(n.label), 1))
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(n.battery_pct != null ? `${n.battery_pct}%` : '—'), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.departedTags.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "topo-departed__head",
                          "aria-expanded": _ctx.departedExpanded,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.departedExpanded = !_ctx.departedExpanded))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["bi bi-chevron-right topo-departed__chevron", { 'topo-departed__chevron--open': _ctx.departedExpanded }])
                          }, null, 2),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.parking.unreachable')) + " (" + _toDisplayString(_ctx.departedTags.length) + ")", 1)
                        ], 8, _hoisted_27),
                        (_ctx.departedExpanded)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_28, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.address')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.battery')), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departedTags, (n) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: n.id
                                  }, [
                                    _createElementVNode("td", null, [
                                      (_ctx.topoLink(n))
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            to: _ctx.topoLink(n)!
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(n.label), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(n.label), 1))
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(n.battery_pct != null ? `${n.battery_pct}%` : '—'), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selNode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["topo-detail__dot", { 'topo-detail__dot--round': _ctx.selNode.kind === 'tag' }]),
                        style: _normalizeStyle({ background: _ctx.nodeFill(_ctx.selNode) })
                      }, null, 6),
                      (_ctx.topoLink(_ctx.selNode))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: _ctx.topoLink(_ctx.selNode)!
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.selNode.label), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock("strong", _hoisted_33, _toDisplayString(_ctx.selNode.label), 1))
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "topo-detail__close",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sel = null))
                    }, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                    ]))])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.nodeType')), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.nodeKindLabel(_ctx.selNode.kind)), 1)
                    ]),
                    (_ctx.selNode.kind === 'gateway')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.gwAddress')), 1),
                            (_ctx.topoLink(_ctx.selNode))
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "mono",
                                  to: _ctx.topoLink(_ctx.selNode)!
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.selNode.id.replace(/^gw:/, '')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.selNode.id.replace(/^gw:/, '')), 1))
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.feature')), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.selNode.type ?? _ctx.$t('components.infrastructure.topology.detail.noType')), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.selNode.kind === 'anchor')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.address')), 1),
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.selNode.id.replace(/^an:/, '')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selNode.kind === 'tag')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.address')), 1),
                            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.selNode.addr ?? '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.status')), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.selNode.status ? _ctx.$t(`components.wirepasAssets.status.${_ctx.selNode.status}`) : '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.hops')), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.selNode.hops != null ? _ctx.selNode.hops : '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.travelTime')), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.selNode.travel_ms != null ? `${_ctx.selNode.travel_ms} ms` : '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.bestRssi')), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.selNode.rssi != null ? `${_ctx.selNode.rssi} dBm` : '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.battery')), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.selNode.battery_pct != null ? `${_ctx.selNode.battery_pct}%` : '—'), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.selNode.kind === 'anchor')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.rssi')), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.selNode.rssi != null ? `${_ctx.selNode.rssi} dBm` : '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.nextHopRssi')), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.selNode.nextHopRssiDbm != null ? `${_ctx.selNode.nextHopRssiDbm} dBm` : '—'), 1)
                          ]),
                          (_ctx.selNode.nextHopAddress != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.nextHop')), 1),
                                _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.selNode.nextHopAddress), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.selNode.kind !== 'tag')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.topology.detail.state')), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.selNode.active === false ? _ctx.$t('components.infrastructure.topology.detail.offline') : _ctx.$t('components.infrastructure.topology.detail.online')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(), _createElementBlock("svg", {
              ref: "svgEl",
              class: "topo-svg",
              viewBox: `0 0 ${_ctx.dims.w} ${_ctx.dims.h}`,
              "preserve-aspect-ratio": "xMidYMid meet",
              role: "img",
              "aria-label": _ctx.$t('components.infrastructure.topology.hint'),
              onPointerdown: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onSvgDown && _ctx.onSvgDown(...args))),
              onPointermove: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onMove && _ctx.onMove(...args))),
              onPointerup: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onUp && _ctx.onUp(...args)))
            }, [
              _createElementVNode("g", {
                transform: `translate(${_ctx.zoom.x},${_ctx.zoom.y}) scale(${_ctx.zoom.k})`
              }, [
                (_ctx.parkLabels.anchors)
                  ? (_openBlock(), _createElementBlock("text", {
                      key: 0,
                      x: _ctx.parkLabels.anchors.x,
                      y: _ctx.parkLabels.anchors.y,
                      "text-anchor": "start",
                      "dominant-baseline": "central",
                      fill: _ctx.C_DIM,
                      "font-size": "11"
                    }, _toDisplayString(_ctx.$t('components.infrastructure.topology.parking.offlineAnchors')) + " (" + _toDisplayString(_ctx.offAnchorCount) + ") →", 9, _hoisted_55))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderLinks, (l, i) => {
                  return (_openBlock(), _createElementBlock("g", {
                    key: `l${i}`,
                    opacity: _ctx.edgeDimmed(l) ? 0.06 : 1
                  }, [
                    (_ctx.linkNode(l.source) && _ctx.linkNode(l.target))
                      ? (_openBlock(), _createElementBlock("line", {
                          key: 0,
                          class: "topo-flow",
                          x1: _ctx.linkNode(l.source)!.x,
                          y1: _ctx.linkNode(l.source)!.y,
                          x2: _ctx.linkNode(l.target)!.x,
                          y2: _ctx.linkNode(l.target)!.y,
                          stroke: _ctx.edgeColor(l),
                          "stroke-width": _ctx.linkId(l.source).startsWith('tag:') ? 1.5 : 1.1,
                          "vector-effect": "non-scaling-stroke"
                        }, null, 8, _hoisted_57))
                      : _createCommentVNode("", true),
                    (l.rssi != null && _ctx.linkNode(l.source) && _ctx.linkNode(l.target))
                      ? (_openBlock(), _createElementBlock("text", {
                          key: 1,
                          x: (_ctx.linkNode(l.source)!.x! + _ctx.linkNode(l.target)!.x!) / 2,
                          y: (_ctx.linkNode(l.source)!.y! + _ctx.linkNode(l.target)!.y!) / 2 - 3,
                          "text-anchor": "middle",
                          fill: _ctx.C_DIM,
                          "font-size": "10"
                        }, _toDisplayString(l.rssi) + " dBm", 9, _hoisted_58))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_56))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderNodes, (n) => {
                  return (_openBlock(), _createElementBlock("g", {
                    key: n.id,
                    class: "topo-node",
                    transform: `translate(${n.x},${n.y})`,
                    opacity: _ctx.nodeDimmed(n) ? 0.12 : 1,
                    onPointerdown: ($event: any) => (_ctx.onNodeDown($event, n))
                  }, [
                    (n.kind === 'gateway')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (n.id === _ctx.sel)
                            ? (_openBlock(), _createElementBlock("rect", {
                                key: 0,
                                x: -_ctx.radiusOf(n) - 5,
                                y: -_ctx.radiusOf(n) - 5,
                                width: (_ctx.radiusOf(n) + 5) * 2,
                                height: (_ctx.radiusOf(n) + 5) * 2,
                                rx: "14",
                                fill: "none",
                                stroke: "#58a6ff",
                                "stroke-width": "1.5"
                              }, null, 8, _hoisted_60))
                            : _createCommentVNode("", true),
                          _createElementVNode("rect", {
                            x: -_ctx.radiusOf(n),
                            y: -_ctx.radiusOf(n),
                            width: _ctx.radiusOf(n) * 2,
                            height: _ctx.radiusOf(n) * 2,
                            rx: "11",
                            fill: _ctx.C_GW,
                            stroke: n.active === false ? _ctx.C_OFF : '#58a6ff',
                            "stroke-width": "2"
                          }, null, 8, _hoisted_61),
                          _createElementVNode("text", {
                            "text-anchor": "middle",
                            y: _ctx.radiusOf(n) + 16,
                            fill: _ctx.C_TEXT,
                            "font-size": "12",
                            "font-weight": "600"
                          }, _toDisplayString(n.label), 9, _hoisted_62)
                        ], 64))
                      : (n.kind === 'anchor')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (n.id === _ctx.sel)
                              ? (_openBlock(), _createElementBlock("rect", {
                                  key: 0,
                                  x: -_ctx.radiusOf(n) - 5,
                                  y: -_ctx.radiusOf(n) - 5,
                                  width: (_ctx.radiusOf(n) + 5) * 2,
                                  height: (_ctx.radiusOf(n) + 5) * 2,
                                  transform: "rotate(45)",
                                  fill: "none",
                                  stroke: "#58a6ff",
                                  "stroke-width": "1.5"
                                }, null, 8, _hoisted_63))
                              : _createCommentVNode("", true),
                            _createElementVNode("rect", {
                              x: -_ctx.radiusOf(n),
                              y: -_ctx.radiusOf(n),
                              width: _ctx.radiusOf(n) * 2,
                              height: _ctx.radiusOf(n) * 2,
                              rx: "3",
                              transform: "rotate(45)",
                              fill: _ctx.C_ANCHOR,
                              stroke: n.active === false ? _ctx.C_OFF : _ctx.C_ANCHOR_BORDER,
                              "stroke-width": "2"
                            }, null, 8, _hoisted_64),
                            _createElementVNode("text", {
                              "text-anchor": "middle",
                              y: _ctx.radiusOf(n) * 1.41 + 14,
                              fill: _ctx.C_TEXT,
                              "font-size": "11"
                            }, _toDisplayString(n.label), 9, _hoisted_65)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (n.id === _ctx.sel)
                              ? (_openBlock(), _createElementBlock("circle", {
                                  key: 0,
                                  r: _ctx.radiusOf(n) + 6,
                                  fill: "none",
                                  stroke: "#58a6ff",
                                  "stroke-width": "1.5"
                                }, null, 8, _hoisted_66))
                              : _createCommentVNode("", true),
                            _createElementVNode("circle", {
                              r: _ctx.radiusOf(n),
                              fill: _ctx.nodeFill(n),
                              stroke: _ctx.CANVAS_BG,
                              "stroke-width": "2.5"
                            }, null, 8, _hoisted_67),
                            _createElementVNode("text", {
                              "text-anchor": "middle",
                              y: _ctx.radiusOf(n) + 15,
                              fill: _ctx.C_TEXT,
                              "font-size": "11"
                            }, _toDisplayString(n.label), 9, _hoisted_68),
                            (n.hops != null)
                              ? (_openBlock(), _createElementBlock("g", {
                                  key: 1,
                                  transform: `translate(${_ctx.radiusOf(n) - 2},${-_ctx.radiusOf(n) - 2})`
                                }, [
                                  _createElementVNode("circle", {
                                    r: "9",
                                    fill: "#161b22",
                                    stroke: _ctx.nodeFill(n),
                                    "stroke-width": "1.5"
                                  }, null, 8, _hoisted_70),
                                  _createElementVNode("text", {
                                    "text-anchor": "middle",
                                    "dominant-baseline": "central",
                                    fill: _ctx.C_TEXT,
                                    "font-size": "10",
                                    "font-weight": "600"
                                  }, _toDisplayString(n.hops), 9, _hoisted_71)
                                ], 8, _hoisted_69))
                              : _createCommentVNode("", true)
                          ], 64))
                  ], 40, _hoisted_59))
                }), 128))
              ], 8, _hoisted_54)
            ], 40, _hoisted_53))
          ], 64))
    ], 512)
  ]))
}